// Match today's relative slot in the displayed period, including historical comparisons.
export function chartScrollOffset(keys, period, viewport, slotWidth, now = new Date()) {
  if (!keys.length || !(viewport > 0) || !(slotWidth > 0)) return 0;
  const date = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Copenhagen',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
  const part = type => date.find(p => p.type === type)?.value;
  const day = `${part('year')}-${part('month')}-${part('day')}`;
  const hour = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Copenhagen',hour:'2-digit',hourCycle:'h23'}).format(now);
  const target = period === 'year' ? `${keys[0].slice(0,4)}-${part('month')}` : period === 'month' ? `${keys[0].slice(0,7)}-${part('day')}` : period === 'day' ? `${keys[0].slice(0,10)}T${hour}` : day;
  let index = keys.findIndex(key => key >= target);
  if (index < 0) index = keys.length - 1;
  return Math.max(0, Math.min(keys.length * slotWidth - viewport, (index + .5) * slotWidth - viewport / 2));
}
